import React from 'react';
import cn from 'classnames';
import { useParams } from 'react-router-dom';

import { getTranslation } from 'helpers/getTranslation';
import { getLessonUploadRequestParams } from 'helpers/lessonAssetPaths.helpers';

import { FormikField } from 'components/FormikField';
import { UploadField, EditableTextField } from 'components/FormikFields';

import styles from './ImageBlock.module.scss';

const ImageBlock = ({
  readOnly,
  namePrefix,
}: {
  readOnly: any;
  namePrefix: any;
}) => {
  const { courseId, lessonId } = useParams();

  return (
    <div className={cn(styles.block, { [styles.readOnlyBlock]: readOnly })}>
      <FormikField
        name={`${namePrefix}.data.url`}
        withControl={false}
        component={UploadField}
        componentProps={{
          readOnly,
          variant: 'imageBlock',
          accept: {
            'image/jpeg': ['.jpg', '.jpeg'],
            'image/png': ['.png'],
            'image/webp': ['.webp'],
          },
          ...getLessonUploadRequestParams({
            courseId,
            lessonId: lessonId as string,
          }),
        }}
      />
      <div className={styles.caption}>
        <div className={styles.captionLine} />
        <FormikField
          name={`${namePrefix}.data.caption`}
          withControl={false}
          component={EditableTextField}
          componentProps={{
            readOnly,
            variant: 'text',
            placeholder: getTranslation(
              'components.theory_blocks.caption_placeholder',
            ),
          }}
        />
      </div>
    </div>
  );
};

export default React.memo(ImageBlock) as any;
